var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form-wrapper", {
    ref: "form",
    staticClass: "expired-lot-business-order-create-form",
    attrs: { "in-modal": true, "scroll-on-error": true },
    on: { submit: _vm.save },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          var loading = ref.loading
          return [
            _c(
              "p",
              {
                staticClass:
                  "expired-lot-business-order-create-form__disclaimer"
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("expiredInventory.businessOrders.disclaimerLine")
                    ) +
                    "\n    "
                )
              ]
            ),
            _c(
              _vm.isTabletSize ? "div" : "base-scroll-container",
              { tag: "component", class: "", attrs: { "is-in-modal": "" } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "expired-lot-business-order-create-form__contorl"
                  },
                  [
                    _c("base-switch", {
                      attrs: {
                        id: "disposalSwitch",
                        value: _vm.disposalSwitch,
                        name: "disposalSwitch",
                        options: _vm.disposalOptions
                      },
                      on: { change: _vm.changeDisposalSwitch }
                    })
                  ],
                  1
                ),
                _c(
                  "collapsible-block",
                  {
                    ref: "collapsible",
                    class: "",
                    attrs: {
                      "title-text": _vm.$t(
                        "businessOrders.labels.orderInformation"
                      ),
                      "preview-only": ""
                    }
                  },
                  [
                    _c("flex-row", { class: "" }, [
                      _c(
                        "div",
                        {
                          staticClass: "field col",
                          staticStyle: { "margin-right": "20px" }
                        },
                        [
                          _c("form-input", {
                            attrs: {
                              id: "reference-number",
                              name: "reference-number",
                              rules: _vm.rules.referenceNumber,
                              label: _vm.$t("businessOrders.labels.referenceNo")
                            },
                            model: {
                              value: _vm.model.referenceNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "referenceNumber",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.referenceNumber"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.warehouses || _vm.warehouses.length != 2
                        ? _c(
                            "div",
                            { staticClass: "field col" },
                            [
                              _c("form-select", {
                                attrs: {
                                  id: "orderWarehouseId",
                                  value: _vm.model.warehouseName,
                                  name: "warehouseName",
                                  rules: "required",
                                  "dropdown-longer-than-input": "",
                                  label: _vm.$t(
                                    "businessOrders.warehouse.shipFrom"
                                  ),
                                  placeholder: "",
                                  options: _vm.warehouses,
                                  searchable: false,
                                  "option-label": "warehouseName",
                                  "value-field": "warehouseId",
                                  "track-by": "warehouseId"
                                },
                                on: { input: _vm.handleWarehouseSelection }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]),
                    _c("bulk-items-lot-table", {
                      class: "",
                      attrs: {
                        id: "items-table",
                        validity: _vm.validity,
                        "item-parent": _vm.model,
                        "is-visible-record-serial-number": true,
                        "invalid-items-count": _vm.invalidItemsCount,
                        "selected-warehouse": _vm.selectedWarehouseName
                      },
                      on: {
                        "delete-item": function(row) {
                          return _vm.deleteItem(row)
                        },
                        "open-edit-item": function(item) {
                          return _vm.onOpenEditItem(item)
                        }
                      }
                    }),
                    _c("flex-row", { class: "" }, [
                      _c(
                        "div",
                        { staticClass: "field col" },
                        [
                          _c("form-textarea", {
                            attrs: {
                              id: "order-comments",
                              name: "order-comments",
                              required: _vm.disposalSwitch === 1,
                              rules: _vm.rules.orderComments,
                              label: _vm.$t(
                                "businessOrders.labels.orderComments"
                              )
                            },
                            model: {
                              value: _vm.model.orderComments,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "orderComments",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.orderComments"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "collapsible-block",
                  {
                    ref: "collapsible",
                    class: "",
                    attrs: {
                      "title-text": _vm.$t(
                        "businessOrders.labels.consigneeInformation"
                      ),
                      "preview-only": ""
                    }
                  },
                  [
                    _c("flex-row", [
                      _c(
                        "div",
                        { staticClass: "field col" },
                        [
                          _c("form-input", {
                            attrs: {
                              id: "consignee-name",
                              name: "consignee-name",
                              rules: _vm.rules.consigneeName,
                              label: _vm.$t(
                                "businessOrders.labels.consigneeName"
                              ),
                              disabled: _vm.isEditingEdi
                            },
                            model: {
                              value: _vm.model.customerName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "customerName",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.customerName"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("flex-row", [
                      _c(
                        "div",
                        {
                          staticClass: "field col",
                          staticStyle: { "margin-right": "20px" }
                        },
                        [
                          _c("form-input", {
                            attrs: {
                              id: "consignee-phone",
                              name: "consignee-phone",
                              rules:
                                _vm.model.country === "US"
                                  ? _vm.rules.consigneePhone
                                  : _vm.rules.consigneePhoneRequired,
                              label: _vm.$t(
                                "businessOrders.labels.consigneePhone"
                              ),
                              disabled: _vm.isEditingEdi
                            },
                            model: {
                              value: _vm.model.customerPhoneNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "customerPhoneNumber",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.customerPhoneNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "field col" },
                        [
                          _c("form-input", {
                            attrs: {
                              id: "consignee-email",
                              name: "consignee-email",
                              rules:
                                _vm.model.country === "US"
                                  ? _vm.rules.consigneeEmail
                                  : _vm.rules.consigneeEmailRequired,
                              label: _vm.$t(
                                "businessOrders.labels.consigneeEmail"
                              ),
                              disabled: _vm.isEditingEdi
                            },
                            model: {
                              value: _vm.model.customerEmail,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "customerEmail",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.customerEmail"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("flex-row", [
                      _c(
                        "div",
                        { staticClass: "field col" },
                        [
                          _c(
                            "form-input",
                            {
                              attrs: {
                                id: "consignee-address-line-1",
                                name: "consignee-address-line-1",
                                rules: _vm.rules.consigneeAddressLine1,
                                label: _vm.$t(
                                  "businessOrders.labels.consigneeAddressLine1"
                                ),
                                disabled: _vm.isEditingEdi
                              },
                              model: {
                                value: _vm.model.streetAddress1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "streetAddress1",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "model.streetAddress1"
                              }
                            },
                            [
                              _c(
                                "template",
                                { slot: "labelTooltip" },
                                [
                                  _c("button-tooltip", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.bottom",
                                        value: {
                                          content: _vm.$t(
                                            "businessOrders.labels.consigneeAddressLine1Tooltip"
                                          ),
                                          delay: { show: 500, hide: 300 }
                                        },
                                        expression:
                                          "{\n                                    content: $t('businessOrders.labels.consigneeAddressLine1Tooltip'),\n                                    delay: { show: 500, hide: 300 },\n                                }",
                                        modifiers: { bottom: true }
                                      }
                                    ]
                                  })
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]),
                    _vm.showSecondAddressLine
                      ? _c("flex-row", [
                          _c(
                            "div",
                            { staticClass: "field col" },
                            [
                              _c("form-input", {
                                attrs: {
                                  id: "consignee-address-line-2",
                                  name: "consignee-address-line-2",
                                  rules: _vm.rules.consigneeAddressLine2,
                                  label: _vm.$t(
                                    "businessOrders.labels.consigneeAddressLine2"
                                  ),
                                  disabled: _vm.isEditingEdi
                                },
                                model: {
                                  value: _vm.model.streetAddress2,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "streetAddress2",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "model.streetAddress2"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      : _c("flex-row", [
                          _c(
                            "div",
                            { staticClass: "col col--on-left" },
                            [
                              _c(
                                "base-button",
                                {
                                  attrs: {
                                    id: "add-address-line",
                                    "as-link": "",
                                    disabled: _vm.isEditingEdi
                                  },
                                  on: { click: _vm.addAddressLine }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        slot: "iconLeft",
                                        width: "20",
                                        height: "20"
                                      },
                                      slot: "iconLeft"
                                    },
                                    [
                                      _c("use", {
                                        attrs: { "xlink:href": "#plus-round" }
                                      })
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$t(
                                          "businessOrders.labels.consigneeAddAddressLine"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                    _c("flex-row", [
                      _c(
                        "div",
                        {
                          staticClass: "field col",
                          staticStyle: { "margin-right": "20px" }
                        },
                        [
                          _c("form-input", {
                            attrs: {
                              id: "city",
                              name: "city",
                              rules: _vm.rules.city,
                              label: _vm.$t("general.addressLabels.city"),
                              disabled: _vm.isEditingEdi
                            },
                            model: {
                              value: _vm.model.city,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "city",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.city"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "field col" },
                        [
                          _c("form-input", {
                            attrs: {
                              id: "state-province",
                              name: "state-province",
                              rules: _vm.rules.stateProvince,
                              label: _vm.$t(
                                "businessOrders.labels.stateProvince"
                              ),
                              disabled: _vm.isEditingEdi
                            },
                            model: {
                              value: _vm.model.stateOrProvince,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "stateOrProvince",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.stateOrProvince"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("flex-row", [
                      _c(
                        "div",
                        {
                          staticClass: "field col col--50-percent",
                          staticStyle: { "margin-right": "20px" }
                        },
                        [
                          _c("form-input", {
                            attrs: {
                              id: "zip-code",
                              name: "zip-code",
                              rules:
                                _vm.model.country === "US"
                                  ? _vm.rules.zipCodeRequired
                                  : _vm.rules.zipCode,
                              label: _vm.$t("general.addressLabels.zipCode"),
                              disabled: _vm.isEditingEdi
                            },
                            model: {
                              value: _vm.model.zipCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "zipCode",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.zipCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "field col col--50-percent" },
                        [
                          _c("form-select", {
                            attrs: {
                              id: "origin-country",
                              value: _vm.model.country,
                              name: "country-region",
                              rules: "required|min:1|max:3",
                              "dropdown-longer-than-input": "",
                              label: _vm.$t(
                                "businessOrders.labels.countryRegion"
                              ),
                              options: _vm.countryCodes,
                              searchable: true,
                              disabled: _vm.isEditingEdi,
                              "option-label": "name",
                              "value-field": "code",
                              "track-by": "name"
                            },
                            on: {
                              input: function(value) {
                                _vm.model.country = value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _c("collapsible-block", {
                  ref: "collapsible",
                  attrs: {
                    "title-text": _vm.$t("businessOrders.labels.handlingUnits"),
                    disabled: ""
                  }
                }),
                _c("collapsible-block", {
                  ref: "collapsible",
                  attrs: {
                    "title-text": _vm.$t(
                      "businessOrders.labels.uploadShippingLabel"
                    ),
                    disabled: ""
                  }
                }),
                _c("collapsible-block", {
                  ref: "collapsible",
                  attrs: {
                    "title-text": _vm.$t(
                      "businessOrders.labels.uploadBillOfLanding"
                    ),
                    disabled: ""
                  }
                }),
                _c("collapsible-block", {
                  ref: "collapsible",
                  attrs: {
                    "title-text": _vm.$t(
                      "businessOrders.labels.uploadShippingDocument"
                    ),
                    disabled: ""
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "modal__actions modal__actions--with-scroll" },
              [
                _c(
                  "base-button",
                  {
                    attrs: { id: "cancelCreateBtn", "for-modal": "" },
                    on: { click: _vm.cancel }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("general.cancel")) +
                        "\n        "
                    )
                  ]
                ),
                _c(
                  "base-button",
                  {
                    attrs: {
                      id: "createItemBtnModal",
                      "for-modal": "",
                      type: "submit",
                      disabled: invalid || loading || !_vm.orderHasValidItems
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("general.save")) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            ),
            _vm.itemForEdit
              ? _c("edit-item-popup", {
                  attrs: {
                    "items-list": _vm.initialSearchItems,
                    "item-parent": _vm.model,
                    "item-for-edit": _vm.itemForEdit,
                    "is-sku-edit-disabled": true,
                    "selected-warehouse": _vm.selectedWarehouseName,
                    "is-visible-record-serial-number": true,
                    "is-display-lot-detail": true
                  },
                  on: {
                    "cancel-editing-item": _vm.cancelEditingItem,
                    "save-editing-item": function(item) {
                      return _vm.saveEditingItem(item)
                    }
                  }
                })
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }